import { motion } from "framer-motion";
import { Droplets, Fan, ScanSearch, ShieldCheck, SprayCan } from "lucide-react";

const steps = [
  {
    icon: ScanSearch,
    num: "01",
    title: "Diagnostic des fibres",
    desc: "Nature du tissu, taches, odeurs et usure : chaque surface est examinée pour choisir le bon protocole.",
  },
  {
    icon: SprayCan,
    num: "02",
    title: "Pré-traitement & détachage",
    desc: "Les taches (café, gras, auréoles, poils d'animaux) sont traitées une par une avec des agents ciblés.",
  },
  {
    icon: Droplets,
    num: "03",
    title: "Injection-extraction",
    desc: "La solution nettoyante est injectée au cœur des fibres puis immédiatement extraite avec les salissures.",
  },
  {
    icon: Fan,
    num: "04",
    title: "Séchage accéléré",
    desc: "Extraction maximale de l'humidité et ventilation : vos textiles sont secs en 2 à 4 heures.",
  },
  {
    icon: ShieldCheck,
    num: "05",
    title: "Contrôle & protection",
    desc: "Vérification finale avec vous, conseils d'entretien et traitement protecteur anti-taches sur demande.",
  },
];

export default function Process() {
  return (
    <section id="methode" data-testid="process-section" className="bg-[#0B131E] py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 max-w-2xl"
        >
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-teal-400 sm:text-sm">
            Notre méthode
          </p>
          <h2 className="font-serif text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl">
            Cinq étapes, zéro compromis
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
            Le protocole professionnel d'injection-extraction, réalisé
            directement chez vous, du diagnostic au séchage.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              data-testid="process-step-card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="group relative rounded-3xl border border-slate-800 bg-[#131F2E] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-teal-700/60"
            >
              <span className="font-serif text-5xl font-semibold text-teal-500/25 transition-colors duration-300 group-hover:text-teal-400/50">
                {step.num}
              </span>
              <step.icon className="mt-6 h-7 w-7 text-teal-400" />
              <h3 className="mt-4 font-serif text-xl font-semibold text-white">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
